<template>
  <div class="team-info">
    <div class="team-title">{{ $t('teamInfo.title') }}</div>
    <div class="form-div">
      <el-form :model="teamInfo" :rules="ruleForm" ref="ruleForm" label="left" class="team-form" label-width="130px">
        <el-form-item class="custom-label" :label="$t('teamInfo.teamName')"
                      :prop="requireField('teamNameJson') ? 'teamName' : ''"
                      v-if="showField('teamNameJson')">
          <el-input v-model="teamInfo.teamName" :placeholder="$t('teamInfo.placeholder')" :maxlength="teamNameMaxLength" show-word-limit :disabled="isTeamSubmitted"></el-input>
        </el-form-item>
        <el-form-item class="custom-label" :label="$t('teamInfo.contactName')"
                      :prop="requireField('realNameJson') ? 'realName' : ''"
                      v-if="showField('realNameJson')">
          <el-input v-model="teamInfo.realName" :placeholder="$t('teamInfo.placeholder')" :disabled="isTeamSubmitted"></el-input>
        </el-form-item>
        <el-form-item class="custom-label" :label="$t('teamInfo.contactPhone')"
                      :prop="requireField('mobileJson') ? 'mobile' : ''"
                      v-if="showField('mobileJson')">
          <el-input v-model="teamInfo.mobile" :placeholder="$t('teamInfo.placeholder')" :disabled="isTeamSubmitted"></el-input>
        </el-form-item>
        <el-form-item class="custom-label" :label="$t('teamInfo.contactEmail')"
                      :prop="requireField('emailJson') ? 'email' : ''"
                      v-if="showField('emailJson')">
          <el-input v-model="teamInfo.email" :placeholder="$t('teamInfo.placeholder')" :disabled="isTeamSubmitted"></el-input>
        </el-form-item>
        <el-form-item class="custom-label" :label="$t('teamInfo.memberUnit')"
                      :prop="requireField('memberUnitJson') ? 'memberUnitId' : ''"
                      v-if="showField('memberUnitJson')">
          <el-select v-model="teamInfo.memberUnitId" :placeholder="$t('teamInfo.placeholder')" filterable clearable
                     style="width: 100%" :disabled="isTeamSubmitted">
            <el-option v-for="item in memberUnitOptions" :key="item.id" :label="item.nameCh" :value="item.id"/>
          </el-select>
          <div class="field-tip" v-if="memberUnitTip">{{ memberUnitTip }}</div>
        </el-form-item>
        <el-form-item class="custom-label" :label="$t('teamInfo.region')"
                      :prop="requireField('regionJson') ? 'regionId' : ''"
                      v-if="showField('regionJson')">
          <el-select v-model="teamInfo.regionId" :placeholder="$t('teamInfo.placeholder')" filterable clearable
                     style="width: 100%" :disabled="isTeamSubmitted">
            <el-option v-for="item in regionOptions" :key="item.id" :label="item.nameCh" :value="item.id"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="button" ><el-button type="primary" @click="saveToNext()" :loading="loginLoading" :disabled="isTeamSubmitted">{{ $t('common.saveAndNext') }}</el-button></div>
    </div>
  </div>
</template>
<script>
import {saveTeamInfo, getMemberUnitList, getRegionList} from "@/api/team";
export default {
  name: "team-info",
  props: {
    teamInfo: {
      type: Object,
      default: function () {
        return {
          teamName: '',
          memberUnitId: '',
          regionId: '',
          realName: '',
          mobile: '',
          email: '',
          status: 1
        }
      }
    },
    competitionFormConfigInfo: {
      type: Object,
      default: function () {
        return {
          id: '',
          competitionId: '',
          teamForm: {},
          athleteForm: {},
          personForm: {},
          summaryForm: {}
        }
      }
    }
  },
  computed: {
    // 是否显示字段
    showField() {
      return (fieldName) => {
        const fieldConfig = this.competitionFormConfigInfo.teamForm[fieldName];
        return fieldConfig && fieldConfig.isShow === 1;
      };
    },
    // 是否必填字段
    requireField() {
      return (fieldName) => {
        const fieldConfig = this.competitionFormConfigInfo.teamForm[fieldName];
        return fieldConfig && fieldConfig.isRequire;
      };
    },
    // 是否验证字段
    validateField() {
      return (fieldName) => {
        const fieldConfig = this.competitionFormConfigInfo.teamForm[fieldName];
        return fieldConfig && fieldConfig.isValidate;
      };
    },
    // 代表队名称最大长度（赛事表单配置，未配置默认12）
    teamNameMaxLength() {
      const fieldConfig = this.competitionFormConfigInfo.teamForm.teamNameJson;
      return (fieldConfig && fieldConfig.maxLength) || 12;
    },
    // 会员单位提示信息（赛事表单配置）
    memberUnitTip() {
      const fieldConfig = this.competitionFormConfigInfo.teamForm.memberUnitJson;
      return (fieldConfig && fieldConfig.description) || '';
    },
    // 表单验证规则
    ruleForm() {
      const rules = {};
      // 代表队名称
      if (this.showField('teamNameJson')) {
        const teamNameRules = [];
        if (this.requireField('teamNameJson')) {
          teamNameRules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        // 代表队名称长度限制
        teamNameRules.push({
          validator: (rule, value, callback) => {
            if (value && value.length > this.teamNameMaxLength) {
              callback(new Error(this.$t('validate.maxLength', {max: this.teamNameMaxLength})));
            } else {
              callback();
            }
          },
          trigger: "blur"
        });
        // 代表队名称格式校验（不允许空格和特殊字符，避免影响图片文件命名）
        teamNameRules.push({
          validator: (rule, value, callback) => {
            if (value && /[\s\\/:*?"<>|#%&$@=+~^`[\]{}']/.test(value)) {
              callback(new Error(this.$t('validate.teamNameFormat')));
            } else {
              callback();
            }
          },
          trigger: "blur"
        });
        if (teamNameRules.length > 0) {
          rules.teamName = teamNameRules;
        }
      }
      // 联系人姓名
      if (this.showField('realNameJson')) {
        const realNameRules = [];
        if (this.requireField('realNameJson')) {
          realNameRules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        if (realNameRules.length > 0) {
          rules.realName = realNameRules;
        }
      }
      // 会员单位
      if (this.showField('memberUnitJson')) {
        const memberUnitRules = [];
        if (this.requireField('memberUnitJson')) {
          memberUnitRules.push({required: true, message: this.$t('validate.required'), trigger: "change"});
        }
        if (memberUnitRules.length > 0) {
          rules.memberUnitId = memberUnitRules;
        }
      }
      // 所在地区
      if (this.showField('regionJson')) {
        const regionRules = [];
        if (this.requireField('regionJson')) {
          regionRules.push({required: true, message: this.$t('validate.required'), trigger: "change"});
        }
        if (regionRules.length > 0) {
          rules.regionId = regionRules;
        }
      }
      // 联系电话
      if (this.showField('mobileJson')) {
        const mobileRules = [];
        if (this.requireField('mobileJson')) {
          mobileRules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        // 验证手机号格式
        if (this.validateField('mobileJson')) {
          mobileRules.push({
            pattern: /^1[3-9]\d{9}$/,
            message: this.$t('validate.formatIncorrect'),
            trigger: "blur"
          });
        }
        if (mobileRules.length > 0) {
          rules.mobile = mobileRules;
        }
      }
      // 联系邮箱
      if (this.showField('emailJson')) {
        const emailRules = [];
        if (this.requireField('emailJson')) {
          emailRules.push({required: true, message: this.$t('validate.required'), trigger: "blur"});
        }
        // 验证邮箱格式
        if (this.validateField('emailJson')) {
          emailRules.push({
            type: 'email',
            message: this.$t('validate.formatIncorrect'),
            trigger: "blur"
          });
        }
        if (emailRules.length > 0) {
          rules.email = emailRules;
        }
      }
      return rules;
    }
  },
  data() {
    return {
      loginLoading: false,
      // 会员单位选项
      memberUnitOptions: [],
      regionOptions: [],
    };
  },
  created() {
    let id = this.$route.query.id;
    if (!id) {
      this.$router.push({ path: "/index" });
    } else {
      this.competitionId = id;
    }
  },
  mounted() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/login?id=" + this.competitionId });
    }
    // 会员单位选项（按当前赛事）
    getMemberUnitList({competitionId: this.competitionId}).then((res) => {
      this.memberUnitOptions = (res.data && res.data.list) || [];
    });
    getRegionList({competitionId: this.competitionId}).then((res) => {
      this.regionOptions = (res.data && res.data.list) || [];
    });
  },
  destroyed() {

  },
  methods: {
    // 保存
    saveToNext(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let params = {
            competitionId: this.competitionId,
            teamName: this.teamInfo.teamName,
            memberUnitId: this.teamInfo.memberUnitId || null,
            regionId: this.teamInfo.regionId || null,
            realName: this.teamInfo.realName,
            mobile: this.teamInfo.mobile,
            email: this.teamInfo.email
          };
          this.loginLoading = true;
          saveTeamInfo(params).then((res) => {
            if (res.code === 200) {
              this.$message.success(res.msg);
              if (res.data && res.data.id) {
                this.teamInfo.id = res.data.id;
              }
              this.$emit('toMain', 'AthleteInfo');
              this.loginLoading = false;
            } else {
              this.$message.error(res.msg);
              this.loginLoading = false;
            }
          });
        } else {
          return false;
        }
      });
    }
  },
};
</script>
<style scoped lang="scss">
.team-info{
  width: 100%;

  .team-title {
    font-size: 22px;
    font-weight: 600;
    color: #333;
    padding-bottom: 12px;
    margin-bottom: 20px;
    border-bottom: 2px solid #1E50AE;
  }

  .form-div{
    margin: 30px auto;
    width: 600px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    padding: 40px;

    .field-tip {
      font-size: 12px;
      color: #909399;
      line-height: 1.5;
      margin-top: 4px;
      text-align: left;
    }

    .button {
      margin-top: 50px;
      text-align: center;

      .el-button {
        padding: 10px 40px;
        font-size: 15px;
      }
    }
  }

}
</style>
